console.log(1);
class Tab extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', this.toggleClass.bind(this));
    }

    toggleClass() {

        console.log(1);
        if(this.classList.contains('active')) {
            this.Close();
        }else {
            
            this.Open();
        }
    }

    Open() {
        this.classList.add('active'); 
    }

    Close() {
        this.classList.remove('active');
    }

}

customElements.define('custom-tab', Tab);